import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';
import { ScrollView, ImageBackground, Text, View } from 'react-native';
import Header from '../../components/Header/Header.web';
import HikingPeople from '../../assets/images/hiking-people.jpg';
import { H1, H2 } from '../../components/UI/TextStyles';
import Section from '../../components/sections/Section';
import Footer from '../../components/footer/Footer';
import Team from '../../assets/images/team.jpg';

function About() {
  return (
    <ScrollView>
      <Header />
      <ImageBackground
        source={HikingPeople}
        style={{
          minHeight: '80vh',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <H1 style={{ color: 'white' }} centered>
          Anreissen. Mitmachen. Erleben.
        </H1>
      </ImageBackground>
      <Section style={{ maxWidth: 500 }} backgroundColor="black">
        <Text
          style={{
            marginBottom: 50,
            marginHorizontal: 30,
            fontSize: 'large',
            textAlign: 'center',
            color: 'white',
          }}
        >
          Viel zu viele Erlebnisse sterben schon, bevor sie überhaupt geboren
          sind. Weil wir zu bequem sind, weil es zu umständlich ist oder weil
          irgendwas anderes dazwischen kommt. Triff hilft dir, das zu ändern.
          Was immer du unternehmen möchtest, mit Triff trommelst du deine Leute
          zusammen. Bist du dabei?
        </Text>
      </Section>
      <img src={Team} width={'100%'} height={'100%'} alt="Team Triff" />
      <Section>
        <H2>Wir sind Triff.</H2>
        <p>
          Die Geschichte von Triff beginnt im Jahr 2016. Inspiriert durch unsere
          Grossmutter haben wir die Mealsharing-Plattform Margrit gegründet –
          benannt nach ihr. Diese Plattform bracht hungrige Menschen an die
          Esstische von Hobbyköchinnen. Quer durch die Schweiz. Von Chur bis
          Basel, und St. Gallen bis Biel.
        </p>
        <p>
          Nach mehreren tausend erfolgreich vermittelten Essen und wunderbaren
          Begegnungen beschlossen wir, das Angebot von Margrit zu erweitern. Die
          neue Plattform sollte Menschen nicht nur zum Essen zusammenbringen,
          sondern für viele andere Aktivitäten auch. Zum Wandern, Walken, Jassen
          und vieles mehr. Egal, was deine Leidenschaft ist, auf unserer
          Plattform sollst du Leute finden, mit denen du dein Erlebnis teilen
          kannst. Egal, ob das deine Freunde sind oder neue Bekanntschaften.
        </p>
        <p>
          Seit Anfang 2019 heisst Margrit Triff. Aber dahinter steht immer noch
          dasselbe Team. Wir, Tobias und Stefan Ganz, zwei Enkel von Margrit.
          Und wir freuen uns über jede neue Begegnung, die wir ermöglichen
          dürfen.
        </p>
        <p>Schön, dass du dabei bist.</p>
        <p>Tobias und Stefan</p>
      </Section>
      <Footer />
    </ScrollView>
  );
}

export default About;
